import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from 'react-apexcharts';

class StandByReq extends Component {

  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: 'Pedidos em stand-by',
        align: 'center',
        margin: 40,
        style: {
          fontSize:  '14px',
          fontWeight:  'bold',
          color:  '#263238'
        }
      },
      labels: [
        'Desde sempre', 
        'Periodo de tempo:'
      ],
      legend: {
        show: true,
        position: "bottom",
        fontSize: '13px'
      },
     colors:['#4d4d4d', '#66CDAA']
    }
  }

  render() {


    return (
      <div>
        {this.props.standByReq && ( 
        <Chart 
          title={this.state.title}
          options={this.state.chartOptions} 
          series={[this.props.standByReq[0].standby_dsd_sp, this.props.standByReq[0].standby_ultimos_90_dias]}
          type="pie" 
          width="480"
          style={{marginTop:-120, marginLeft:10}}
        /> 
        )}
        {this.props.filter_slider && this.props.filter_slider != null ?
          <div class="label_slider3_dates">definido no filtro</div> : <div class="label_slider3_predef">últimos 90 dias </div>
        }
      </div>

    );
  }
}
export default StandByReq;
